import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toHandlers as _toHandlers, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_MLBadge = _resolveComponent("MLBadge")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_WaveformVerifyDialog = _resolveComponent("WaveformVerifyDialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_table, _mergeProps({
      pagination: _ctx.pagination,
      "table-header-class": "bg-blue-brand text-white",
      rows: _ctx.rows,
      columns: _ctx.columns,
      "row-key": _ctx.rowKey,
      "sort-method": _ctx.sortMethod,
      "hide-bottom": _ctx.hideBottom,
      dense: "",
      loading: _ctx.loading,
      "no-data-label": _ctx.noDataLabel
    }, _toHandlers(_ctx.rowClickListeners(_ctx.rowOpensChart, _ctx.onRowClick)), { "onUpdate:pagination": _ctx.onUpdatePagination }), {
      "body-cell-graph-data": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            (_ctx.isManualPassage(props.row))
              ? (_openBlock(), _createBlock(_component_q_badge, {
                  key: 0,
                  color: "grey",
                  class: "q-mr-xs"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getWaveformLabel('H')), 1)
                  ]),
                  _: 1
                }))
              : ((props.row.passageWaveforms || []).length === 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.passageWaveforms, (wf) => {
                      return (_openBlock(), _createBlock(_component_q_btn, {
                        key: wf.passageWaveformId,
                        size: "sm",
                        class: "q-mr-xs btn-brand",
                        dense: "",
                        icon: "show_chart",
                        label: _ctx.getWaveformLabel(wf.passageWaveformType),
                        onClick: ($event: any) => (_ctx.onShowChart(props.row, wf))
                      }, null, 8, ["label", "onClick"]))
                    }), 128))
                  ]))
                : ((props.row.passageWaveforms || []).length > 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                      _createVNode(_component_q_btn_dropdown, {
                        size: "sm",
                        class: "q-mr-xs btn-brand",
                        dense: "",
                        icon: "show_chart"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_list, { dense: "" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.passageWaveforms, (wf) => {
                                return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                  key: wf.passageWaveformId,
                                  clickable: "",
                                  onClick: ($event: any) => (_ctx.onShowChart(props.row, wf))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_item_section, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_item_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.getWaveformLabel(wf.passageWaveformType)), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])), [
                                  [_directive_close_popup]
                                ])
                              }), 128))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  : _createCommentVNode("", true),
            (!props.row.passageId)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "[manual passage] "))
              : _createCommentVNode("", true),
            (
              !props.row.passageId &&
              (_ctx.getuser() == 'admin' || _ctx.getuser() == 'superadmin')
            )
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 4,
                  size: "sm",
                  class: "btn-brand",
                  dense: "",
                  color: "blue-brand",
                  icon: "edit",
                  onClick: ($event: any) => (_ctx.onConfirmEditManualPassage(props.row))
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-uid": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.value), 1)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-verify-data": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            (props.row.passageId)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  size: "sm",
                  class: "btn-brand",
                  dense: "",
                  color: _ctx.isAnyWaveformVerified(props.row) ? 'green' : 'red',
                  icon: 
              _ctx.isAnyWaveformVerified(props.row)
                ? 'check_circle_outline'
                : 'block'
            ,
                  onClick: ($event: any) => (_ctx.onVerifyPassage(props.row))
                }, null, 8, ["color", "icon", "onClick"]))
              : _createCommentVNode("", true),
            (
              !props.row.passageId &&
              (_ctx.getuser() == 'admin' || _ctx.getuser() == 'superadmin')
            )
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 1,
                  size: "sm",
                  class: "btn-brand",
                  dense: "",
                  color: "red",
                  icon: "delete",
                  onClick: ($event: any) => (_ctx.onConfirmDeleteManualPassage(props.row))
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-machine-learning-data": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMLWaveforms(props.row), (wf) => {
              return (_openBlock(), _createBlock(_component_MLBadge, {
                key: wf.passageWaveformId,
                type: wf.passageWaveformType,
                prediction: wf.mlPrediction,
                confidence: wf.mlConfidence,
                results: wf.machineLearningResults,
                tooltip: 
              _ctx.mlOpensChart
                ? `View ${_ctx.getWaveformLabel(wf.passageWaveformType)} waveform`
                : undefined
            ,
                "data-testid": _ctx.mlOpensChart ? 'view-passages-ml-result' : undefined,
                onClick: ($event: any) => (_ctx.onMLBadgeClick(props.row, wf))
              }, null, 8, ["type", "prediction", "confidence", "results", "tooltip", "data-testid", "onClick"]))
            }), 128))
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      _: 1
    }, 16, ["pagination", "rows", "columns", "row-key", "sort-method", "hide-bottom", "loading", "no-data-label", "onUpdate:pagination"]),
    _createVNode(_component_WaveformVerifyDialog, {
      ref: "waveformVerifyDialog",
      onConfirm: _ctx.onWaveformVerifyConfirm,
      onCancel: _ctx.onWaveformVerifyCancel
    }, null, 8, ["onConfirm", "onCancel"])
  ]))
}